jQuery(function ($) {
  $(document).on(
    'click',
    '.product-filters-title-control, .close-product-filters',
    function () {
      $(
        '.filters-wrapper.product-archive-sidebar--widget > .filters-wrapper'
      ).toggleClass('active');
    }
  );

  function handleProductFilterChange(productFilters, currentRequest) {
    // - generate filterUrlParams
    // - ajax request
    // - history.push

    // var querystringFilters = {};
    // for(var filterKey of Object.keys(productFilters.filters)) {
    //   if(filterKey === 'brand') {
    //     if(productFilters.filters[filterKey])
    //   }
    // }
    productFilters.querystring = $.param(productFilters.filters);

    window.history.pushState(
      { href: productFilters.url + '?' + productFilters.querystring },
      '',
      productFilters.url + '?' + productFilters.querystring
    );

    loadProducts(productFilters, currentRequest);
  }

  function loadProducts(productFilters, currentRequest) {
    currentRequest = $.ajax({
      url: vitalshop_load_products_params.ajaxurl,
      data: {
        action: 'vitalshop_load_filtered_products',
        query: vitalshop_load_products_params.posts,
        filters: productFilters.filters,
        querystring: productFilters.querystring,
      },
      type: 'POST',
      beforeSend: function (xhr) {
        if (currentRequest != null) {
          currentRequest.abort();
        }
      },
      success: function (res) {
        try {
          var result = JSON.parse(res);

          $('.product-archive-product-grid').html(result.products);
          $('.pagination-wrapper').html(result.pagination);
          $('.product-count > .count').html(result.total);
        } catch (error) {
          // console.error('Error parsing AJAX response:', error);
        }
      },
      error: function (xhr, status, error) {
        // console.error('AJAX request failed:', status, error);
        // Optional: Show user-friendly error message
        // $('.product-archive-product-grid').html('<p>Fehler beim Laden der Produkte. Bitte versuchen Sie es erneut.</p>');
      },
    });
  }

  $(document).ready(function () {
    var currentRequest = null;

    var productFilters = {
      url: vitalshop_load_products_params.url,
      urlParamsBefore: vitalshop_load_products_params.query_params,
      querystring: '',
      filters: {
        brand: [],
        minPrice: undefined,
        maxPrice: undefined,
        ingridient: [],
      },
    };

    // console.log(
    //   'vitalshop_load_products_params.posts:',
    //   vitalshop_load_products_params.posts
    // );

    productFilters.filters = {
      ...productFilters.filters,
      ...productFilters.urlParamsBefore,
    };

    // Set up event listeners

    $(document).on('click', '.drop-filter-button', function (e) {
      e.preventDefault();
      var filterToDrop = $(this).attr('data-drop-filter');

      if (filterToDrop == 'brand') {
        $('input.product-filter--brand').each(function () {
          $(this).prop('checked', false);
        });
        productFilters.filters.brand = [];
      }

      if (filterToDrop == 'ingridient') {
        $('input.product-filter--ingridient').each(function () {
          $(this).prop('checked', false);
        });
        productFilters.filters.ingridient = [];
      }

      if (filterToDrop == 'price') {
        productFilters.filters.minPrice = 0;
        productFilters.filters.maxPrice = parseFloat(
          vitalshop_load_products_params.max_product_price
        );

        priceRangeSlider.set([
          productFilters.filters.minPrice,
          productFilters.filters.maxPrice,
        ]);
      }

      handleProductFilterChange(productFilters, currentRequest);
    });

    $(document).on('change', 'input.product-filter--brand', function () {
      productFilters.filters.brand = [];
      $('input.product-filter--brand').each(function () {
        if ($(this).is(':checked')) {
          productFilters.filters.brand.push($(this).attr('value'));
        }
      });
      handleProductFilterChange(productFilters, currentRequest);
    });

    $(document).on('change', 'input.product-filter--ingridient', function () {
      productFilters.filters.ingridient = [];
      $('input.product-filter--ingridient').each(function () {
        if ($(this).is(':checked')) {
          productFilters.filters.ingridient.push($(this).attr('value'));
        }
      });
      handleProductFilterChange(productFilters, currentRequest);
    });

    $(document).on('change', '#product-order-select', function () {
      productFilters.filters.orderby = $('#product-order-select').val();
      handleProductFilterChange(productFilters, currentRequest);
    });

    if ($('#range-slider').length) {
      var slider = document.getElementById('range-slider');
      var maxAvailablePrice = vitalshop_load_products_params.max_product_price;
      var priceRangeSlider = noUiSlider.create(slider, {
        start: [
          parseFloat(vitalshop_load_products_params.minPrice),
          parseFloat(vitalshop_load_products_params.maxPrice),
        ],
        connect: true,
        range: {
          min: 0,
          max: parseFloat(maxAvailablePrice),
        },
      });

      priceRangeSlider.on('update', function (values) {
        $('#range-slider')
          .closest('.range-slider-group')
          .find('.range-label.price-start')
          .html(values[0]);
        $('#range-slider')
          .closest('.range-slider-group')
          .find('.range-label.price-end')
          .html(values[1]);

        $('#range-slider')
          .closest('.range-slider-group')
          .find('#price_min')
          .val(values[0]);
        $('#range-slider')
          .closest('.range-slider-group')
          .find('#price_max')
          .val(values[1]);

        productFilters.filters.minPrice = values[0];
        productFilters.filters.maxPrice = values[1];
      });

      // call ajax after debounce only
      priceRangeSlider.on(
        'update',
        $.debounce(25, function (e) {
          if (!$('#range-slider').attr('loaded')) {
            $('#range-slider').attr('loaded', true);
          } else {
            handleProductFilterChange(productFilters, currentRequest);
          }
        })
      );
    }
  });
});
